import React from 'react'
import './Button.sass'

const Button = (props) => {
    return (
        <button
			onClick={props.click}
			className={props.className}
			disabled={props.disabled ? props.disabled : false}
        >{props.title}</button>
    )
}

export default Button

export const EditButton = (props) => (
	<button
		type={props.type ? props.type : ''}
		onClick={props.click}
		className="no__edit-button"
	>
		{props.children}
	</button>
)
